export function notNull<T>(val: T | null): val is T {
  return val != null;
}

export function notUndefined<T>(val: T | undefined): val is T {
  return val != undefined;
}
